
import Vue from 'vue'
import DentalTopTooth from "./DentalTopTooth.vue";
// import axios from "axios";
import { DentalToothMarkings, DentalCondition, DentalToothNote } from '../../../types/Sapphire_dto'
import { DentalToothNotation } from 'types/DentalToothNotation'

const ToothImage = Vue.extend({
    components: { DentalTopTooth },
    name: "tooth-image",
    props: {
        toothID: Number,
        sessionID: Number,
        patientId: String,
        stamps: Array as () => Array<String>,
        toothMarkings:  Array as () => Array<DentalToothMarkings>,
        missingToothFlag: Boolean,
        selectedToothFlag: Boolean,
        toothNotes: Array as () => Array<DentalToothNote>,
        dentalConditionList: Array as () => Array<DentalCondition>,
        toothNotationList: Array as () => Array<DentalToothNotation>,
    },
    mounted: function () {
        // this.drawCanvasBackground();
    },
    watch: {
        stamps: function (newVal, oldVal) {
          if (newVal != oldVal) {
            this.reset();
          }
        }
    },
    data() {
      return {
        selectedLogFilterID: 0,
        dateFilterFrom: "",
        dateFilterTo: "",
        treatments: [],
      };
    },
    methods: {
      GetBackgroundImage() {
          return 'background: url(../../../Common/Images/dental/tooth' + this.toothID + '.png) no-repeat center center;';
      },
      async reset() {
        //Refresh SVG on changes
        document.getElementById("tooth" + this.toothID).innerHTML = "";
        // var canvasContext;
        //   const f_canvas = document.getElementById("cnCanvasTooth" + this.toothID) as HTMLCanvasElement;
        //   canvasContext = f_canvas.getContext("2d");
        //   var img = new Image();
        //   canvasContext.drawImage(img, 0, 0);

        for (var i = 0; i < this.stamps.length; i++) {
                // this.drawTreatmentImage(
                //   this.dentalItems[i].waitlistTreatmentID,
                //   this.dentalItems[i].LogType)
          var svg = document.getElementById( "tooth" + this.toothID ).innerHTML;
           let thisStamp = this.stamps[i];
          //call for Images
          if (thisStamp) {
              document.getElementById("tooth" + this.toothID).innerHTML += thisStamp;
          }

          document.getElementById("tooth" + this.toothID).innerHTML += svg;
        }
      },
      ToothSelected() {
          this.$emit("toothSelected", this.toothID);
      },
      toothButtonSectionStyle() {
          let s = this.toothID < 17 ? 'order: 1; margin-top: 5px;' : 'order: 4';
          return "flex-grow:1; " +  s;
      },
      toothNotationSectionStyle() {
        let s = this.toothID < 17 ? 'order: 2' : 'order: 3';
          var returnStyle = 'font-size: 16px; font-weight: bold; text-align: center; height: 20px; flex-grow:1; ' + s;

          return returnStyle;
      },
      toothImageSectionStyle() {
          let s = this.toothID < 17 ? 'order: 3' : 'order: 2';
          return "height: 115px; flex-grow:1; " +  s;
      },
      toothTopToothSectionStyle() {
          let s = this.toothID < 17 ? 'order: 4' : 'order: 1';
          return "height: 50px; flex-grow:1; " +  s;
      },
      // async drawTreatmentImage(treatmentId: number, logTypeID: number) {
      //   var vm = this;
      //   var canvasContext;

      //   const f_canvas = document.getElementById("cnCanvasTooth" + this.toothID) as HTMLCanvasElement;
      //   canvasContext = f_canvas.getContext("2d");
      //   var img = new Image();
      //   canvasContext.drawImage(img, 0, 0);

      //   //call for Images
      //   vm.getStampImage_New(treatmentId, logTypeID);
      // },
      // async drawCanvasBackground() {
      //   const cn = document.getElementById("cnCanvasTooth" + this.toothID) as HTMLCanvasElement;

      //   var canvasContext = cn.getContext("2d");
      //   var img = new Image();

      //   img.src = "../../../Common/Images/dental/tooth" + this.toothID + ".png";

      //   await img.decode()
      //   cn.width = img.width;
      //   cn.height = img.height;

      //   canvasContext.drawImage(img, 0, 0);
      // },
      // async getStampImage_New(treatmentID, logTypeID) {
      //   var svg = document.getElementById( "tooth" + this.toothID ).innerHTML;

      //   const response = await axios.post(
      //       "../../../Common/Services/EhrTaskService.svc/GetStampImage",
      //       {
      //         treatmentID: treatmentID,
      //         LogType: logTypeID,
      //         toothID: this.toothID
      //       }
      //     )

      //     let ret_uri = JSON.parse(response.data.d);
      //     if (ret_uri  && ret_uri.length > 0) {
      //         document.getElementById("tooth" + this.toothID).innerHTML += ret_uri;
      //     }

      //   document.getElementById("tooth" + this.toothID).innerHTML += svg;
      // },
    },
});


export type ToothImageRef = InstanceType<typeof ToothImage>;
export default ToothImage;

